import React from 'react'

export const InfoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0002 2.20801C14.3035 2.20801 17.7918 5.6972 17.7918 9.99967C17.7918 14.3039 14.3035 17.7913 10.0002 17.7913C5.6968 17.7913 2.2085 14.3039 2.2085 9.99967C2.2085 5.6972 5.6968 2.20801 10.0002 2.20801ZM10.0002 0.833008C4.94563 0.833008 0.833496 4.9452 0.833496 9.99967C0.833496 15.0542 4.94563 19.1663 10.0002 19.1663C15.0547 19.1663 19.1668 15.0542 19.1668 9.99967C19.1668 4.9452 15.0547 0.833008 10.0002 0.833008Z"
        fill="#011533"
      />
      <path
        d="M11.6918 11.9022C10.892 14.0882 7.83663 14.6749 8.40305 11.8413L9.07097 8.63379H10.4677C10.1437 10.344 9.91043 11.3861 9.6779 12.5803C9.44549 13.7943 10.9529 12.894 11.2971 11.9022H11.6918Z"
        fill="#011533"
      />
      <path
        d="M9.52991 7.44657C9.36161 7.26726 9.27881 7.05169 9.27881 6.77692C9.29067 6.51396 9.37347 6.29884 9.55352 6.10777C9.74464 5.92857 9.96027 5.83301 10.2342 5.83301C10.5089 5.83301 10.7127 5.92857 10.8919 6.10777C11.0829 6.29884 11.1794 6.51396 11.1794 6.77692C11.1794 7.05169 11.0712 7.26726 10.8802 7.44657C10.6889 7.62578 10.4608 7.70948 10.1986 7.70948C9.93654 7.70948 9.70827 7.62578 9.52991 7.44657Z"
        fill="#011533"
      />
    </svg>
  )
}
